import React from 'react';

const Icon = ({ size = '24', ...other }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...other}>
            <path
                d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Z"
                stroke="#757575"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />

            <path d="m8 13 4-4 4 4" stroke="#757575" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};
export default React.memo(Icon);
